module.exports = __webpack_public_path__ + "img/maison12.6091a9e8.jpg";